type RowObj = {
	name: [string, boolean];
	progress: string;
	quantity: number;
	date: string; 
};

const tableDataCheck: RowObj[] = [
	{
		name: [ 'Camila Diaz', true ],
		quantity: 2458,
		progress: '17.5%',
		date: '12 Enero 2021',
	},
	{
		name: [ 'Juan Perez', true ],
		quantity: 1485,
		progress: '10.8%',
		date: '12 Enero 2021',
	},
	{
		name: [ 'Diana Mendez', true ],
		quantity: 1024,
		progress: '21.3%',
		date: '12 Enero 2021',
	},
	{
		name: [ 'Maria mendez', true ],
		quantity: 858,
		progress: '31.5%',
		date: '12 Enero 2021',
	},
	{
		name: [ 'Cesar mora', true ],
		quantity: 258,
		progress: '12.2%',
		date: '12 Enero 2021',
	}
];

export default tableDataCheck;
